export class DataCatalogPipelineLineage {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "pipelineId",
            "baseName": "pipelineId",
            "type": "string",
            "format": ""
        },
        {
            "name": "pipelineVersion",
            "baseName": "pipelineVersion",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lineageRecorded",
            "baseName": "lineageRecorded",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sources",
            "baseName": "sources",
            "type": "Array<DataCatalogLineageSource>",
            "format": ""
        },
        {
            "name": "missingSourceCount",
            "baseName": "missingSourceCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "hiddenSourceCount",
            "baseName": "hiddenSourceCount",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineLineage.attributeTypeMap;
    }
    constructor() {
    }
}
